import styles from './ReviewRatings.module.scss'
import classNames from 'classnames'
import { ReviewRatingsProps } from './types'
import { DEFAULT_RATINGS } from 'components/review-ratings/Constants'
import Score from 'components/review-ratings/components/Score'

const ReviewRatings = ({ className, show = DEFAULT_RATINGS }: ReviewRatingsProps) => {
  return (
    <ul className={classNames(styles.ratings, className)}>
      {show.vnr && (
        <li>
          <Score instance="vnr" logoProps={{ width: 16 }} />
        </li>
      )}

      {show.googleReviews && (
        <li>
          <Score instance="googleReviews" logoProps={{ height: 16 }} />
        </li>
      )}

      {show.trustpilot && (
        <li>
          <Score instance="trustpilot" logoProps={{ height: 16 }} />
        </li>
      )}
    </ul>
  )
}

export default ReviewRatings
